@let emptyBasket = isBasketEmpty();
@let hasABasket = hasBasket();
@let saving = isSaving();
@let editable = isEditable();
@let locked = isLocked();
@let userBasket = isUserBasket();
@let UIEditable = (editable || (!editable && locked));
@let UIBtnSavingOrLockedDisabled = (saving || locked);
@let optionsOpened = optionsPanelOpened();
@let bwMigration = hasBWMigration();

@if (hasABasket) {
  <div class="group/OptionsPanel
              z-10 overflow-hidden
              size-full
              grid
              justify-stretch
              items-start
              grid-rows-[3rem_0rem_0.75rem]
              [&.opened]:grid-rows-[3rem_4.5rem_0.75rem]
              [&.opened.bw-migration]:grid-rows-[3rem_6.5rem_0.75rem]
              transition-all"
    [class.opened]="optionsOpened"
    [class.bw-migration]="bwMigration">


    <div class="z-20 overflow-hidden
                size-full
                grid
                grid-cols-[1fr_4rem]
                justify-start
                items-center
                gap-x-2">
      <div class="size-full overflow-hidden inline-flex justify-center items-center">
        @if (UIEditable) {
          <input class="w-full py-1 px-2 mx-2
                        text-sm font-medium truncate rounded
                        bg-slate-50 outline outline-slate-50 outline-2
                        hover:outline-orange-100
                        hover:bg-orange-50
                        [&.user-basket]:outline-primary-light
                        [&.user-basket]:bg-primary-light
                        [&.user-basket]:hover:outline-green-100
                        [&.user-basket]:hover:bg-green-50
                        hover:cursor-text
                        transition-all
                        invalid:outline-red-100
                        invalid:bg-warn-light
                        disabled:pointer-events-none
                        disabled:text-gray-600
                        disabled:bg-gray-50
                        disabled:outline-gray-100"
            type="text"
            required
            [class.user-basket]="userBasket"
            [formControl]="basketNameFormControl">
        } @else {
          <div class="w-full text-center font-medium truncate rounded py-1 px-2 mx-1 bg-gray-50">
            {{basketName()}}
          </div>
        }
      </div>

      <div class="size-full grid grid-cols-2 gaps-x-2 justify-end items-center mr-1">
        @if (UIEditable) {
          @if (saving) {
            <SpinnerIcon color="primary"/>
          } @else {
            <button  small ripple accent icon mirButton
              [attr.danger]="!userBasket || null"
              [title]="saveBtnTooltip()"
              [disabled]="emptyBasket"
              (click)="handleSaveBasket($event)">
              <MirIcon>{{saveIcon()}}</MirIcon>
            </button>
          }


        @if (locked) {
          <div class="size-full grid place-items-center">
            <MirIcon size="small"
                [color]="userBasket ? 'gray-900' : 'slate-900'"
                [title]="lockTooltip()">
              lock
            </MirIcon>
          </div>
        } @else {
            <button small ghost icon mirButton
                [matMenuTriggerFor]="MoreMenu">
              <MirIcon>more_vert</MirIcon>
            </button>
          }
        }
      </div>
    </div>

    <div class="z-10 overflow-hidden
                block
                size-full">
      <div class="-z-10 overflow-hidden w-full px-2 pb-3 pt-1
                  flex flex-col justify-start items-start gap-y-2">
        <mir-select class="!text-sm !h-6 !w-full"
          [title]="'Versions.Referential.Label' | translate"
          [options]="referentialList()"
          (selectionChange)="handleChangeReferential($event)">
        </mir-select>

        <mir-select class="!text-sm !h-6 !w-full"
          [title]="'Versions.Default.Label' | translate"
          [options]="versionList()"
          (selectionChange)="handleChangeVersion($event)">
        </mir-select>

        @if (bwMigration) {
          <SlideCheckbox
              class="w-full text-xs overflow-hidden pt-2"
              color="primary"
              labelFullWidth highlightLabel
              [checked]="isBWMigrationChecked()"
              (change)="handleToggleBWMigration($event)">
            <div class="truncate overflow-hidden w-[calc(100%_-_0.25rem)]">
              BW Migration
            </div>
          </SlideCheckbox>
        }
      </div>
    </div>

    <div class="z-20 overflow-hidden
                size-full
                inline-flex justify-center items-center
                shadow-2">
      <button small ghost cover icon mirButton
            class="group
              !bg-[whitesmoke]
              hover:!bg-gray-200"
          [title]="optionsPanelTooltip()"
          (click)="handleToggleOptionsPanel($event)">
        <MirIcon size="normal" class="group-[&.opened]/OptionsPanel:rotate-180 scale-125">
          arrow_drop_down
        </MirIcon>
      </button>
    </div>
  </div>

}

<mat-menu #MoreMenu="matMenu">

  <div class="bg-white rounded py-2 flex flex-col">

    <button mirButton small start cover
        [disabled]="UIBtnSavingOrLockedDisabled"
        (click)="handleNewBasket($event)">
      <MirIcon color="primary">news</MirIcon>
      {{'Wizard.Panel.UI.Labels.New' | translate}}
    </button>

    <hr>

    <button mirButton small start cover
        [disabled]="UIBtnSavingOrLockedDisabled"
        (click)="handleCreateNewCopy($event)">
      <MirIcon color="accent">note_stack_add</MirIcon>
      {{'Wizard.Panel.UI.Labels.NewCopy' | translate}}
    </button>

    <hr>

    <button mirButton small start cover
        [disabled]="UIBtnSavingOrLockedDisabled || emptyBasket || !userBasket"
        (click)="handleClearBasket($event)">
      <MirIcon color="danger">restart_alt</MirIcon>
      {{'Wizard.Panel.UI.Labels.Reset' | translate}}
    </button>

    <hr>

    <button mirButton small start cover
        [disabled]="UIBtnSavingOrLockedDisabled"
        (click)="handleDeleteBasket($event)">
      <MirIcon color="warn">close</MirIcon>
      {{'Wizard.Panel.UI.Labels.Clear' | translate}}
    </button>

    <!-- 🧪 test UI 🪄 -->
    @if (canUseUndo()) {
      <hr>

      @let count = historyCount();

      <button mirButton cover small start
          [disabled]="UIBtnSavingOrLockedDisabled || emptyBasket || count === 0"
          (click)="handleCancelAddition($event)">
        <MirIcon>undo</MirIcon>
        🧪 {{'UI.Cancel' | translate}} [{{count}}]
      </button>
    }

  </div>

</mat-menu>
<!-- 🪛-->
